import { oz } from '@weft/utils';
import { ApiDateSchema } from '../../../primitives';

export const UpcomingRenewalNotificationMetadataSchema = oz.object({
  date: ApiDateSchema,
  contractEndDate: ApiDateSchema,
  contractName: oz.string(),
  contractId: oz.string(),
}).openapi('UpcomingRenewalNotificationMetadata');

export type UpcomingRenewalNotificationMetadata = oz.infer<typeof UpcomingRenewalNotificationMetadataSchema>;